module.exports = __webpack_public_path__ + "img/Group 1300.dc6dbde.png";